import { Component, Input, OnInit } from '@angular/core';
import { PrCardType } from '../pr-card/pr-card.component';

export class PrCardCenter {
  icon: string;
  label: string;
  value: any;
  type: PrCardType;
  tooltip: string;
  display: string;
  fill: boolean;

  constructor(
    icon: string,
    label: string,
    type: PrCardType,
    value: any,
    tooltip?: string,
    display: string = 'neutral',
    fill: boolean = false,
  ) {
    this.icon = icon;
    this.label = label;
    this.type = type;
    this.value = value;
    if (tooltip) this.tooltip = tooltip;
    if (display == null) display = 'neutral';
    else this.display = display;
    this.fill = fill;
  }
}

/**
 * @var icon
 * reference https://fontawesome.com/v4.7/icons/
 *
 * Les variables sont projetés avec <ng-content> pour permettre d'utiliser les pipes/directives
 * Conseil d'utilisation simple :
 * @var value <em value>Valeur</em>
 * @var title <em title>Titre</em>
 */

@Component({
    selector: 'pr-card-center',
    templateUrl: './pr-card-center.component.html',
    styleUrls: ['./pr-card-center.component.scss'],
    standalone: false
})
export class PrCardCenterComponent implements OnInit {
  @Input() icon: string;
  @Input() label: string;
  @Input() value: any;
  @Input() type: PrCardType;
  @Input() tooltip: string;
  @Input() display: string;
  @Input() loading: boolean = false;

  @Input() set cardCenter(cardCenter: PrCardCenter) {
    this.icon = cardCenter.icon;
    this.label = cardCenter.label;
    this.type = cardCenter.type;
    this.tooltip = cardCenter.tooltip;
    this.display = cardCenter.display;

    // Handle value as an observable or as a simple value
    if (cardCenter.value && typeof cardCenter.value == 'object')
      cardCenter.value.subscribe(value => (this.value = value));
    else this.value = cardCenter.value;
  }

  PrCardType = PrCardType;

  constructor() {}

  ngOnInit() {}
}
